import UserManagement from "../pages/UserManagementMaster/UserManagement/UserManagement";
import UserManagementAdd from "../pages/UserManagementMaster/UserManagement/UserManagementAdd";
import UserManagementEdit from "../pages/UserManagementMaster/UserManagement/UserManagementEdit";
import UserType from "../pages/UserManagementMaster/UserType/UserType";
import RoleMaster from "../pages/UserManagementMaster/RoleMaster/RoleMaster";
import UserPermissionMaster from "../pages/UserManagementMaster/UserPermissionMaster/UserPermissionMaster";
import MenuMaster from "../pages/master/Menu/MenuMaster";
import MenuMasterAdd from "../pages/master/Menu/MenuMasterAdd";
import MenuMasterEdit from "../pages/master/Menu/MenuMasterEdit";
import HomePage from "../pages/home/HomePage";
import LoginPage from "../loginPage/LoginPage";
import { RouteType } from "./config";
import HomeIcon from "@mui/icons-material/Home";
import DashboardPageLayout from "../pages/master/MasterPageLayout";
import DashboardIndex from "../pages/master/MasterPageIndex";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import ItemDimension from "../pages/master/ItemDimension/ItemDimention";
import ItemDimensionAdd from "../pages/master/ItemDimension/ItemDimentionAdd";
import ItemDimensionEdit from "../pages/master/ItemDimension/ItemDimentionEdit";
import LightType from "../pages/master/LightType/LightType";
import LightTypeAdd from "../pages/master/LightType/LightTypeAdd";
import LightTypeEdit from "../pages/master/LightType/LightTypeEdit";
import ItemStatus from "../pages/master/ItemStatus/ItemStatus";

import ZoneMaster from "../pages/master/ZoneMaster/ZoneMaster";
import WardMaster from "../pages/master/WardMaster/WardMaster";
import DepartmentMaster from "../pages/master/DepartmentMaster/DepartmentMaster";
import DesignationMaster from "../pages/master/DesignationMaster/DesignationMaster";
import StateMaster from "../pages/master/StateMaster/StateMaster";
import GenderMaster from "../pages/master/GenderMaster/GenderMaster";
import CountryMaster from "../pages/master/CountryMaster/CountryMaster";
import CityMaster from "../pages/master/CityMaster/CityMaster";
import Storemaster from "../pages/master/Storemaster/Storemaster";
import VendorMaster from "../pages/master/VendorMaster/VendorMaster";
import ItemGroup from "../pages/master/ItemGroup/ItemGroup";
import Taxmaster from '../pages/master/Taxmaster/Taxmaster';
import Unitmaster from "../pages/master/Unitmaster/Unitmaster";
import ItemMasters from "../pages/master/ItemMasters/ItemMasters";
//import Stockledger from "../pages/master/Stockledger/Stockledger";
import Jurisdiction from "../pages/master/Jurisdiction/Jurisdiction";
import NodePermission from "../pages/master/NodePermission/NodePermission";
import PollMaster from "../pages/master/PollMaster/PollMaster";
import PollMasterAdd from "../pages/master/PollMaster/PollMasterAdd";
import PollMasterEdit from "../pages/master/PollMaster/PollMasterEdit";
import PoleType from "../pages/master/PoleType/PoleType";
import IndentFormMaster from "../pages/Inventory/IndentForm/IndentFormMaster";
import CreateIndentForm from "../pages/Inventory/IndentForm/CreateIndentForm";
import EditIndentForm from "../pages/Inventory/IndentForm/EditIndentForm";
//import CreateComplaint from "../pages/Inventory/Complaint/CreateComplaint";
//import ComplaintMaster from "../pages/Inventory/Complaint/ComplaintMaster";
//import EditComplaint from "../pages/Inventory/Complaint/EditComplaint";

import LightMaster from "../pages/master/LightMaster/LightMaster";
import LightMasterAdd from "../pages/master/LightMaster/LightMasterAdd";
import LightMasterEdit from "../pages/master/LightMaster/LightMasterEdit";
import PoleInstallation from "../pages/PoleInstallation/PoleInstallation";
import PoleInstallationAdd from "../pages/PoleInstallation/PoleInstallationAdd";
import PoleInstallationEdit from "../pages/PoleInstallation/PoleInstallationEdit";
import LightInstallation from "../pages/LightInstallation/LightInstallation";
import LightInstallationAdd from "../pages/LightInstallation/LightInstallationAdd";
import LightInstallationEdit from "../pages/LightInstallation/LightInstallationEdit";






import MaterialRecieptNoteMaster from "../pages/Inventory/MaterialRecieptNote/MaterialRecieptNoteMaster";
import CreateMaterialRecieptNote from "../pages/Inventory/MaterialRecieptNote/CreateMaterialRecieptNote";
import EditMaterialRecieptNote from "../pages/Inventory/MaterialRecieptNote/EditMaterialRecieptNote";
import EditVendor from "../pages/master/VendorMaster/EditVendor";
import CreateVendor from "../pages/master/VendorMaster/CreateVendor";
import QualityCheckMaster from "../pages/Inventory/QualityCheck/QualityCheckMaster";
import CreateQualityCheck from "../pages/Inventory/QualityCheck/CreateQualityCheck";
import EditQualityCheck from "../pages/Inventory/QualityCheck/EditQualityCheck";
import ItemCategory from "../pages/master/ItemCategory/ItemCategory";
import IndentApproval from "../pages/Inventory/IndentApproval/IndentApproval";
import EditIndentApproval from "../pages/Inventory/IndentApproval/EditIndentApproval";
import CreateIndentApproval from "../pages/Inventory/IndentApproval/CreateIndentApproval";
import ForwardLevel from "../pages/Inventory/ForwardIndentLevel2/ForwardLevel";
import CreateForwardLevel from "../pages/Inventory/ForwardIndentLevel2/CreateForwardLevel";
import EditForwardLevel from "../pages/Inventory/ForwardIndentLevel2/EditForwardLevel";
import IndentStore from "../pages/Inventory/IndentStorePass/IndentStore";
import CreateIndentStore from "../pages/Inventory/IndentStorePass/CreateIndentStore";
import EditIndentStore from "../pages/Inventory/IndentStorePass/EditIndentStore";
import EmployeeMaster from "../pages/Employee/EmployeeMaster";
import EmployeeAdd from "../pages/Employee/EmployeeAdd";
import EmployeeEdit from "../pages/Employee/EmployeeEdit";
import ItemType from "../pages/master/ItemType/ItemType";
import EditJobCard from "../pages/Inventory/JobWork/EditJobCard";
import CreateItemMaster from "../pages/master/ItemMasters/CreateItemMaster";
import EditItemMaster from "../pages/master/ItemMasters/EditItemMaster";
import CreateStockledger from "../pages/master/Stockledger/CreateStockledger";
import EditStockledger from "../pages/master/Stockledger/EditStockledger";
import JobCardMaster from "../pages/Inventory/JobWork/JobCardMaster";
import CreateJobCard from "../pages/Inventory/JobWork/CreateJobCard";
import JobWorkChallanMaster from "../pages/Inventory/Job Work Challan/JobWorkChallanMaster";
import CreateJobWorkChallan from "../pages/Inventory/Job Work Challan/CreateJobWorkChallan";
import EditJobWorkChallan from "../pages/Inventory/Job Work Challan/EditJobWorkChallan";
import JobWorkChallanReceiveMaster from "../pages/Inventory/Job Work Challan Receive/JobWorkChallanReceiveMaster";
import CreateJobWorkChallanReceive from "../pages/Inventory/Job Work Challan Receive/CreateJobWorkChallanReceive";
import EditJobWorkChallanReceive from "../pages/Inventory/Job Work Challan Receive/EditJobWorkChallanReceive";
import StaffIndent from "../pages/Inventory/StaffIndent/StaffIndent";
import CreateStaffIndent from "../pages/Inventory/StaffIndent/CreateStaffIndent";
import EditStaffIndent from "../pages/Inventory/StaffIndent/EditStaffIndent";
import StaffItemIssue from "../pages/Inventory/staffItemIssue/StaffItemIssue";
import CreateStaffItemIssue from "../pages/Inventory/staffItemIssue/CreateStaffItemIssue";
import EditStaffItemIssue from "../pages/Inventory/staffItemIssue/EditStaffItemIssue";
import StaffItemReturn from "../pages/Inventory/StaffItemReturn/StaffItemReturn";
import CreateStaffItemReturn from "../pages/Inventory/StaffItemReturn/CreateStaffItemReturn";
import EditStaffItemReturn from "../pages/Inventory/StaffItemReturn/EditStaffItemReturn";
//import ComplaintType from "../pages/master/ComplaintType/ComplaintType";
import Emailsettingmaster from "../pages/Emailsystem/Emailsetting/Emailsettingmaster";
import EmailcampgianMaster from "../pages/Emailsystem/Emailcampagian/Emailcampagianmaster";
import CreatemailcampgiontForm from "../pages/Emailsystem/Emailcampagian/Createcampgainform";
import Editcampgianmailmaster from "../pages/Emailsystem/Emailcampagian/Editcampagianmaster";
import EmaileventMaster from "../pages/Emailsystem/EmailEventSettings/EmaileventMaster";
import CreatemaileventForm from "../pages/Emailsystem/EmailEventSettings/CreatemaileventForm";
import Editeventemail from "../pages/Emailsystem/EmailEventSettings/Editeventemail";
import CampaignTemplate from "../pages/Emailsystem/CampaignTemplate/CampaignTemplate";
import AddCampaignTemplate from "../pages/Emailsystem/CampaignTemplate/AddCampaignTemplate";
import EditCampaignTemplate from "../pages/Emailsystem/CampaignTemplate/EditCampaignTemplate";
import Editgroupmaster from "../pages/Emailsystem/Group/Editgroupmaster";
import Creategroupmaster from "../pages/Emailsystem/Group/Creategroupmaster";
import Groupmaster from "../pages/Emailsystem/Group/Groupmaster";
import CreateRosterGroup from "../pages/master/RosterGroup/CreateRosterGroup";
import RosterGroup from "../pages/master/RosterGroup/RosterGroup";
import EditRosterGroup from "../pages/master/RosterGroup/EditRosterGroup";

//import ComplainAssignMaster from "../pages/master/ComplainAssignMaster/ComplainAssignMaster";
import InventoryToAsset from "../pages/Inventory/InventoryToAsset/InventoryToAsset";
import AreaMaster from "../pages/master/AreaMaster/AreaMaster";
import RouteMaster from "../pages/master/RouteMaster/RouteMaster";
import Login_Page from "../loginPage/Login_Page";
import RosterVisit from "../pages/master/RosterVisit/RosterVisit";
import ComplaintMaster from "../pages/ComplaintMaster/Complaint/ComplaintMaster";
import ComplainAssignMaster from "../pages/ComplaintMaster/ComplainAssignMaster/ComplainAssignMaster";
import CreateComplaint from "../pages/ComplaintMaster/Complaint/CreateComplaint";
import EditComplaint from "../pages/ComplaintMaster/Complaint/EditComplaint";
import ComplaintType from "../pages/ComplaintMaster/ComplaintType/ComplaintType";
import PurchaseOrderMaster from "../pages/Inventory/PurchaseOrder/PurchaseOrderMaster";
import CreatePurchaseOrder from "../pages/Inventory/PurchaseOrder/CreatePurchaseOrder";
import EditPurchaseOrder from "../pages/Inventory/PurchaseOrder/EditPurchaseOrder";
import PurchaseReturn from "../pages/Inventory/PurchaseReturn/PurchaseReturn";
import CreatePurchaseReturn from "../pages/Inventory/PurchaseReturn/CreatePurchaseReturn";
import EditPurchaseReturnOrder from "../pages/Inventory/PurchaseReturn/EditPurchaseReturnOrder";
import StockLedgerReport from "../pages/Inventory/Reports/StockLedgerReport";
import StockReport from "../pages/Inventory/Reports/StockReport";
import Stockledger from "../pages/Inventory/Opening Stock/Stockledger";
import MrnDetails from "../pages/Inventory/MRN/MrnDetails";
import MrnDetailsAdd from "../pages/Inventory/MRN/MrnDetailsAdd";
import MrnDetailsEdit from "../pages/Inventory/MRN/MrnDetailsEdit";
import ComplainApproval from "../pages/ComplaintMaster/ComplainApproval/ComplainApproval";
import ComplainApprovalMaster from "../pages/ComplaintMaster/ComplainApproval/ComplainApprovalMaster";

import BrandMaster from "../pages/master/BrandMaster/BrandMaster";

import NewPurchaseOrder from "../pages/Inventory/NewPurchaseOrder/NewPurchaseOrder";
import NewPurchaseOrderAdd from "../pages/Inventory/NewPurchaseOrder/NewPurchaseOrderAdd";
import NewPurchaseOrderEdit from "../pages/Inventory/NewPurchaseOrder/NewPurchaseOrderEdit";
import Lightswitchonoff from "../pages/Lightswitchonoff/Lightswitchonoff";
import DeviceInstallMaster from "../pages/DeviceInstallation/DeviceInstallMaster";
import CreateDeviceInstall from "../pages/DeviceInstallation/CreateDeviceInstall";
import EditDeviceInstall from "../pages/DeviceInstallation/EditDeviceInstall";
import Institute from "../pages/InstitueForm/Institute";
import InstituteAdd from "../pages/InstitueForm/InstituteAdd";
import InstituteEdit from "../pages/InstitueForm/InstituteEdit";
import AddEmailsetting from "../pages/Emailsystem/Emailsetting/AddEmailsetting";
import EditEmailsetting from "../pages/Emailsystem/Emailsetting/EditEmailsetting";
import HsnMaster from "../pages/master/HsnMaster/HsnMaster";
import WarrantyMaster from "../pages/master/WarrantyMaster/WarrantyMaster";
import StatusMaster from "../pages/master/StatusMaster/StatusMaster";
import Escrap from "../pages/Inventory/Reports/Escrap";
import PoleInstallReport from "../pages/Inventory/Reports/PoleInstallReport";
import MrnReport from "../pages/Inventory/Reports/MrnReport";
import QcReport from "../pages/Inventory/Reports/QcReport";
import PurchaseBillReport from "../pages/Inventory/Reports/PurchaseBillReport";
import DeviceSchedule from "../pages/Installation/DeviceSchedule/DeviceSchedule";
import ComplaintsReport from "../pages/Inventory/Reports/ComplaintsReport";
import PageSetup from "../pages/master/PageSetup/PageSetup";
import HelpCreation from "../pages/master/HelpCreation/HelpCreation";
import HelpDesk from "../pages/master/HelpDesk/HelpDesk";





const appRoutes: RouteType[] = [
  {
    index: true,
    element: <Login_Page />,
    state: "home",
  },
  {
    element: <HomePage />,
    state: "home",
    path: "/home",
    sidebarProps: {
      displayText: "Home",
      icon: <HomeIcon />,
    },
  },

  {
    path: "/master",
    element: <DashboardPageLayout />,
    state: "master",
    sidebarProps: {
      displayText: "Master",
      icon: <DashboardOutlinedIcon />,
    },
    child: [
      {
        index: true,
        element: <DashboardIndex />,
        state: "master.index",
      },
      {
        path: "/master/MenuMaster",
        element: <MenuMaster />,
        state: "master.MenuMaster",
        sidebarProps: {
          displayText: "Menu Master",
        },
      },
      {
        path: "/master/MenuMasterAdd",
        element: <MenuMasterAdd />,
        state: "master.MenuMasterAdd",
      },
      {
        path: "/master/MenuMasterEdit",
        element: <MenuMasterEdit />,
        state: "master.MenuMasterEdit",
      },
      {
        path: "/master/ZoneMaster",
        element: <ZoneMaster />,
        state: "master.ZoneMaster",
        sidebarProps: {
          displayText: "Zone Master",
        },
      },
      {
        path: "/master/WardMaster",
        element: <WardMaster />,
        state: "master.WardMaster",
        sidebarProps: {
          displayText: "Ward Master",
        },
      },
      {
        path: "/master/DepartmentMaster",
        element: <DepartmentMaster />,
        state: "master.DepartmentMaster",
        sidebarProps: {
          displayText: "Department Master",
        },
      },
      {
        path: "/master/DesignationMaster",
        element: <DesignationMaster />,
        state: "master.DesignationMaster",
        sidebarProps: {
          displayText: "Designation Master",
        },
      },
      {
        path: "/master/CityMaster",
        element: <CityMaster />,
        state: "master.CityMaster",
        sidebarProps: {
          displayText: "District",
        },
      },
      {
        path: "/master/StateMaster",
        element: <StateMaster />,
        state: "master.StateMaster",
        sidebarProps: {
          displayText: "State",
        },
      },

    
      {
        path: "/master/GenderMaster",
        element: <GenderMaster />,
        state: "master.GenderMaster",
        sidebarProps: {
          displayText: "Gender",
        },
      },
      {
        path: "/master/CountryMaster",
        element: <CountryMaster />,
        state: "master.CountryMaster",
        sidebarProps: {
          displayText: "Country",
        },
      },
      {
        path: "/master/ItemDimension",
        element: <ItemDimension />,
        state: "master.ItemDimension",
        sidebarProps: {
          displayText: "Item Dimension",
        },
      },
      {
        path: "/master/ItemDimensionAdd",
        element: <ItemDimensionAdd />,
        state: "master.ItemDimensionAdd",
      },
      {
        path: "/master/ItemDimensionEdit",
        element: <ItemDimensionEdit />,
        state: "master.ItemDimensionEdit",
      },
      {
        path: "/master/LightType",
        element: <LightType />,
        state: "master.LightType",
        sidebarProps: {
          displayText: "Light Type",
        },
      },
      {
        path: "/master/LightTypeAdd",
        element: <LightTypeAdd />,
        state: "master.LightTypeAdd",
      },
      {
        path: "/master/LightTypeEdit",
        element: <LightTypeEdit />,
        state: "master.LightTypeEdit",
      },
      {
        path: "/master/ItemType",
        element: <ItemType />,
        state: "master.ItemType",
      },
      {
        path: "/master/ComplaintType",
        element: <ComplaintType />,
        state: "master.ComplaintType",
      },


      {
        path: "/master/Storemaster",
        element: <Storemaster />,
        state: "master.Storemaster",
        sidebarProps: {
          displayText: "Store master",
        },
      },
      {
        path: "/master/VendorMaster",
        element: <VendorMaster />,
        state: "master.VendorMaster",
        sidebarProps: {
          displayText: "Vendor Master",
        },
      },
      {

        path: "/master/CreateVendor",
        element: <CreateVendor />,
        state: "master.CreateVendor",
      },
      {
        path: "/master/EditVendor",
        element: <EditVendor />,
        state: "master.EditVendor",

      },
      {
        path: "/master/ItemCategory",
        element: <ItemCategory />,
        state: "master.ItemCategory",
        sidebarProps: {
          displayText: "ItemCategory",
        },
      },

      {
        path: "/master/ItemGroup",
        element: <ItemGroup />,
        state: "master.ItemGroup",
        sidebarProps: {
          displayText: "Item Group",
        },
      },
      {
        path: "/master/Taxmaster",
        element: <Taxmaster />,
        state: "master.Taxmaster",
        sidebarProps: {
          displayText: "Tax master",
        },
      },
      {
        path: "/master/Unitmaster",
        element: <Unitmaster />,
        state: "master.Unitmaster",
        sidebarProps: {
          displayText: "Unit master",
        },
      },
      {
        path: "/master/ItemMasters",
        element: <ItemMasters />,
        state: "master.ItemMasters",
        sidebarProps: {
          displayText: "Item Masters",
        },
      },
      {

        path: "/master/CreateItemMaster",
        element: <CreateItemMaster />,
        state: "master.CreateItemMaster",
      },
      {
        path: "/master/EditItemMaster",
        element: <EditItemMaster />,
        state: "master.EditItemMaster",

      },
      // {
      //   path: "/master/Stockledger",
      //   element: <Stockledger />,
      //   state: "master.Stockledger",
      //   sidebarProps: {
      //     displayText: "Stock Ledger",
      //   },
      // },
      {

        path: "/master/CreateStockledger",
        element: <CreateStockledger />,
        state: "master.CreateStockledger",
      },
      {
        path: "/master/EditStockledger",
        element: <EditStockledger />,
        state: "master.EditStockledger",

      },

      {
        path: "/master/Jurisdiction",
        element: <Jurisdiction />,
        state: "master.Jurisdiction",
        sidebarProps: {
          displayText: "Jurisdiction",
        },
      },
      {
        path: "/master/NodePermission",
        element: <NodePermission />,
        state: "master.NodePermission",
        sidebarProps: {
          displayText: "Node Permission",
        },
      },
      {
        path: "/master/PollMaster",
        element: <PollMaster />,
        state: "master.PollMaster",
        sidebarProps: {
          displayText: "Poll Master",
        },
      },
      {
        path: "/master/PollMasterAdd",
        element: <PollMasterAdd />,
        state: "master.PollMasterAdd",

      },
      {
        path: "/master/PollMasterEdit",
        element: <PollMasterEdit />,
        state: "master.PollMasterEdit",
      },
      {
        path: "/master/PoleType",
        element: <PoleType />,
        state: "master.PoleType",
        sidebarProps: {
          displayText: "Pole Type",
        },
      },



      {
        path: "/master/LightMaster",
        element: <LightMaster />,
        state: "master.LightMaster",
        sidebarProps: {
          displayText: "Light Master",
        },
      },
      {
        path: "/master/LightMasterAdd",
        element: <LightMasterAdd />,
        state: "master.LightMasterAdd",

      },
      {
        path: "/master/LightMasterEdit",
        element: <LightMasterEdit />,
        state: "master.LightMasterEdit",

      },


      {
        path: "/master/RosterGroup",
        element: <RosterGroup />,
        state: "master.RosterGroup",
        sidebarProps: {
          displayText: "Roster Group",
        }
      },
      {
        path: "/master/CreateRosterGroup",
        element: <CreateRosterGroup />,
        state: "master.CreateRosterGroup",
      },
      {
        path: "/master/EditRosterGroup",
        element: <EditRosterGroup />,
        state: "master.EditRosterGroup",
      },

      {
        path: "/master/ComplainAssignMaster",
        element: <ComplainAssignMaster />,
        state: "master.ComplainAssignMaster",

      },
      {
        path: "/master/AreaMaster",
        element: <AreaMaster />,
        state: "master.AreaMaster",

      },
      {
        path: "/master/RouteMaster",
        element: <RouteMaster />,
        state: "master.RouteMaster",

      },
      {
        path: "/master/RosterVisit",
        element: <RosterVisit />,
        state: "master.RosterVisit",

      },
      {
        path: "/master/BrandMaster",
        element: <BrandMaster />,
        state: "master.BrandMaster",

      },

      {
        path: "/master/HsnMaster",
        element: <HsnMaster />,
        state: "master.HsnMaster",

      },

      {
        path: "/master/WarrantyMaster",
        element: <WarrantyMaster />,
        state: "master.WarrantyMaster",

      },

      {
        path: "/master/StatusMaster",
        element: <StatusMaster />,
        state: "master.StatusMaster",

      },



    ],

  },



  //======================Master Form End========================



  /////-------------------start ------Inventory-----------------------

  {
    path: "/Inventory",
    element: <DashboardPageLayout />,
    state: "Inventory",

    sidebarProps: {
      displayText: "Inventory",
      icon: <DashboardOutlinedIcon />
    },

    child: [
      {
        index: true,
        element: <DashboardIndex />,
        state: "Inventory.index",
      },

      // {
      //   path: "/Inventory/Purchaseorder",
      //   element: <PurchaseOrderMaster />,
      //   state: "Inventory.Purchaseorder",
      //   sidebarProps: {
      //     displayText: "Purchase Order",
      //   },
      // },

      // {
      //   path: "/Inventory/CreatePurchaseOrder",
      //   element: <CreatePurchaseOrder />,
      //   state: "Inventory.CreatePurchaseOrder",
      // },
      // {
      //   path: "/Inventory/EditPurchaseOrder",
      //   element: <EditPurchaseOrder />,
      //   state: "Inventory.EditPurchaseOrder",
      // },
      {
        path: "/Inventory/ComplaintMaster",
        element: <ComplaintMaster />,
        state: "Inventory.ComplaintMaster",
        sidebarProps: {
          displayText: "Complaint",
        },
      },
      {
        path: "/Inventory/CreateComplaint",
        element: <CreateComplaint />,
        state: "Inventory.CreateComplaint",

      },
      {
        path: "/Inventory/EditComplaint",
        element: <EditComplaint />,
        state: "Inventory.EditComplaint",

      },

      // {
      //   path: "/Inventory/ComplainApproval",
      //   element: <ComplainApproval/>,
      //   state: "Inventory.ComplainApproval",

      // },


      // {
      //   path: "/Inventory/ComplainApprovalMaster",
      //   element: <ComplainApprovalMaster/>,
      //   state: "Inventory.ComplainApprovalMaster",

      // },
      {
        path: "/Inventory/JobCardMaster",
        element: <JobCardMaster />,
        state: "Inventory.JobCardMaster",
        sidebarProps: {
          displayText: "Job Card",
        },
      },
      {
        path: "/Inventory/CreateJobCard",
        element: <CreateJobCard />,
        state: "Inventory.CreateJobCard",

      },
      {
        path: "/Inventory/EditJobCard",
        element: <EditJobCard />,
        state: "Inventory.EditJobCard",

      },
      {
        path: "/Inventory/IndentForm",
        element: <IndentFormMaster />,
        state: "Inventory.IndentForm",
        sidebarProps: {
          displayText: "Indent Form",
        }
      },
      {
        path: "/Inventory/CreateIndentForm",
        element: <CreateIndentForm />,
        state: "Inventory.CreateIndentForm",
      },
      {
        path: "/Inventory/EditIndentForm",
        element: <EditIndentForm />,
        state: "Inventory.EditIndentForm",
      },
      {
        path: "/Inventory/MRNForm",
        element: <MaterialRecieptNoteMaster />,
        state: "Inventory.MRNForm",
        sidebarProps: {
          displayText: "Material Recpt Notes",
        }
      },
      {
        path: "/Inventory/CreateMRN",
        element: <CreateMaterialRecieptNote />,
        state: "Inventory.CreateMRN",
      },
      {
        path: "/Inventory/EditMRN",
        element: <EditMaterialRecieptNote />,
        state: "Inventory.EditMRN",
      },
      {
        path: "/Inventory/QualityCheck",
        element: <QualityCheckMaster />,
        state: "Inventory.QualityCheck",
        sidebarProps: {
          displayText: "Quality Check",
        }
      },
      {
        path: "/Inventory/CreateQualityCheck",
        element: <CreateQualityCheck />,
        state: "Inventory.CreateQualityCheck",
      },
      {
        path: "/Inventory/EditQualityCheck",
        element: <EditQualityCheck />,
        state: "Inventory.EditQualityCheck",
      },


      // {
      //   path: "/Inventory/IndentApproval",
      //   element: <IndentApproval />,
      //   state: "Inventory.IndentApproval",
      //   sidebarProps: {
      //     displayText: "Indent Approval",
      //   }
      // },
      // {
      //   path: "/Inventory/CreateIndentApproval",
      //   element: <CreateIndentApproval />,
      //   state: "Inventory.CreateIndentApproval",
      // },
      // {
      //   path: "/Inventory/EditIndentApproval",
      //   element: <EditIndentApproval />,
      //   state: "Inventory.EditIndentApproval",
      // },

      {
        path: "/Inventory/ForwardLevel",
        element: <ForwardLevel />,
        state: "Inventory.ForwardLevel",
        sidebarProps: {
          displayText: "Forward Level",
        }
      },
      {
        path: "/Inventory/CreateForwardLevel",
        element: <CreateForwardLevel />,
        state: "Inventory.CreateForwardLevel",
      },
      {
        path: "/Inventory/EditForwardLevel",
        element: <EditForwardLevel />,
        state: "Inventory.EditForwardLevel",
      },
      {
        path: "/Inventory/IndentStore",
        element: <IndentStore />,
        state: "Inventory.IndentStore",
        sidebarProps: {
          displayText: "Indent Store",
        }
      },
      {
        path: "/Inventory/CreateIndentStore",
        element: <CreateIndentStore />,
        state: "Inventory.CreateIndentStore",
      },
      {
        path: "/Inventory/EditIndentStore",
        element: <EditIndentStore />,
        state: "Inventory.EditIndentStore",
      },
      {
        path: "/Inventory/JobWorkChallan",
        element: <JobWorkChallanMaster />,
        state: "Inventory.JobWorkChallan",
        sidebarProps: {
          displayText: "Job Work Challan",
        }
      },
      {
        path: "/Inventory/CreateJobWorkChallan",
        element: <CreateJobWorkChallan />,
        state: "Inventory.CreateJobWorkChallan",
      },
      {
        path: "/Inventory/EditJobWorkChallan",
        element: <EditJobWorkChallan />,
        state: "Inventory.EditJobWorkChallan",
      },
      // {
      //   path: "/Inventory/StaffIndent",
      //   element: <StaffIndent />,
      //   state: "Inventory.StaffIndent",
      //   sidebarProps: {
      //     displayText: "Staff Indent",
      //   }
      // },
      // {
      //   path: "/Inventory/CreateStaffIndent",
      //   element: <CreateStaffIndent />,
      //   state: "Inventory.CreateStaffIndent",
      // },
      // {
      //   path: "/Inventory/EditStaffIndent",
      //   element: <EditStaffIndent />,
      //   state: "Inventory.EditStaffIndent",
      // },

      // {
      //   path: "/Inventory/StaffItemIssue",
      //   element: <StaffItemIssue />,
      //   state: "Inventory.StaffItemIssue",
      //   sidebarProps: {
      //     displayText: "Staff Item Issue",
      //   }
      // },
      // {
      //   path: "/Inventory/CreateStaffItemIssue",
      //   element: <CreateStaffItemIssue />,
      //   state: "Inventory.CreateStaffItemIssue",
      // },
      // {
      //   path: "/Inventory/EditStaffItemIssue",
      //   element: <EditStaffItemIssue />,
      //   state: "Inventory.EditStaffItemIssue",
      // },

      // {
      //   path: "/Inventory/StaffItemReturn",
      //   element: <StaffItemReturn />,
      //   state: "Inventory.StaffItemReturn",
      //   sidebarProps: {
      //     displayText: "Staff Item Return",
      //   }
      // },
      // {
      //   path: "/Inventory/CreateStaffItemReturn",
      //   element: <CreateStaffItemReturn />,
      //   state: "Inventory.CreateStaffItemReturn",
      // },
      // {
      //   path: "/Inventory/EditStaffItemReturn",
      //   element: <EditStaffItemReturn />,
      //   state: "Inventory.EditStaffItemReturn",
      // },
      {
        path: "/Inventory/InventoryToAsset",
        element: <InventoryToAsset />,
        state: "Inventory.InventoryToAsset",
      },
      {
        path: "/Inventory/PurchaseInvoice",
        element: <PurchaseOrderMaster />,
        state: "Inventory.PurchaseInvoice",
        sidebarProps: {
          displayText: "Purchase Invoice",
        },
      },

      {
        path: "/Inventory/CreatePurchaseInvoice",
        element: <CreatePurchaseOrder />,
        state: "Inventory.CreatePurchaseInvoice",
      },
      {
        path: "/Inventory/EditPurchaseInvoice",
        element: <EditPurchaseOrder />,
        state: "Inventory.EditPurchaseInvoice",
      },



      {
        path: "/Inventory/PurchaseReturn",
        element: <PurchaseReturn />,
        state: "Inventory.PurchaseReturn",
        sidebarProps: {
          displayText: "Purchase Return",
        },
      },

      {
        path: "/Inventory/CreatePurchaseReturn",
        element: <CreatePurchaseReturn />,
        state: "Inventory.CreatePurchaseReturn",
      },
      {
        path: "/Inventory/EditPurchaseReturn",
        element: <EditPurchaseReturnOrder />,
        state: "Inventory.EditPurchaseReturn",
      },


      {
        path: "/Inventory/StockLedger",
        element: <Stockledger />,
        state: "Inventory.StockLedger",
        sidebarProps: {
          displayText: "Opening Stock",
        },
      },


      // {
      //   path: "/Inventory/StockLedgerReport",
      //   element: <StockLedgerReport />,
      //   state: "Inventory.StockLedgerReport",
      //   sidebarProps: {
      //     displayText: "Stock Summary",
      //   },
      // },


      // {
      //   path: "/Inventory/StockReport",
      //   element: <StockReport />,
      //   state: "Inventory.StockReport",
      //   sidebarProps: {
      //     displayText: "Stock Report",
      //   },
      // },


      {
        path: "/Inventory/MrnDetails",
        element: <MrnDetails />,
        state: "Inventory.MrnDetails",
        sidebarProps: {
          displayText: "MRN Details",
        },
      },

      {
        path: "/Inventory/MrnDetailsAdd",
        element: <MrnDetailsAdd />,
        state: "Inventory.MrnDetailsAdd",
      },
      {
        path: "/Inventory/MrnDetailsEdit",
        element: <MrnDetailsEdit />,
        state: "Inventory.MrnDetailsEdit",
      },


      {
        path: "/Inventory/NewPurchaseOrder",
        element: <NewPurchaseOrder />,
        state: "Inventory.NewPurchaseOrder",
        sidebarProps: {
          displayText: "Purchase",
        },
      },

      {
        path: "/Inventory/NewPurchaseOrderAdd",
        element: <NewPurchaseOrderAdd />,
        state: "Inventory.NewPurchaseOrderAdd",
      },
      {
        path: "/Inventory/NewPurchaseOrderEdit",
        element: <NewPurchaseOrderEdit />,
        state: "Inventory.NewPurchaseOrderEdit",
      },








    ]

  },


  //=================Aniket sahu Emailroute start ===================
  {
    path: "/emailsystem",
    element: <DashboardPageLayout />,
    state: "emailsystem",
    sidebarProps: {
      displayText: "emailsystem",
      icon: <DashboardOutlinedIcon />,
    },
    child: [
      {
        path: "/emailsystem/Groupmaster",
        element: <Groupmaster />,
        state: "emailsystem.Groupmaster",
        sidebarProps: {
          displayText: "Groupmaster",
        },
      },
      {

        path: "/emailsystem/Creategroupmaster",
        element: <Creategroupmaster />,
        state: "emailsystem.Creategroupmaster",
      },
      {
        path: "/emailsystem/Editgroupmaster",
        element: <Editgroupmaster />,
        state: "emailsystem.Editgroupmaster",

      },

      {
        path: "/emailsystem/emailsetting",
        element: <Emailsettingmaster />,
        state: "email.emailMaster",
      },


      {
        path: "/emailsystem/AddEmailSetting",
        element: <AddEmailsetting />,
        state: "email.AddEmailSetting",
      },


      {
        path: "/emailsystem/EditEmailSetting",
        element: <EditEmailsetting />,
        state: "email.EditEmailSetting",
      },



      {
        path: "/emailsystem/campagianmaster",
        element: <EmailcampgianMaster />,
        state: "email.emailMaster",
      },
      {
        path: "/emailsystem/addcampagianmaster",
        element: <CreatemailcampgiontForm />,
        state: "email.emailMaster",
      },
      {
        path: "/emailsystem/editcampagianmaster",
        element: <Editcampgianmailmaster />,
        state: "email.emailMaster",
      },
      {
        path: "/emailsystem/eventmaster",
        element: <EmaileventMaster />,
        state: "email.emailMaster",
      },
      {
        path: "/emailsystem/addeventmaster",
        element: <CreatemaileventForm />,
        state: "email.emailMaster",
      },
      {
        path: "/emailsystem/editeventnmaster",
        element: <Editeventemail />,
        state: "email.emailMaster",
      },

      {
        path: "/emailsystem/CampaignTemplate",
        element: <CampaignTemplate />,
        state: "emailsystem.CampaignTemplate",
        sidebarProps: {
          displayText: "CampaignTemplate",
        },
      },
      {

        path: "/emailsystem/AddCampaignTemplate",
        element: <AddCampaignTemplate />,
        state: "emailsystem.AddCampaignTemplate",
      },
      {
        path: "/emailsystem/EditCampaignTemplate",
        element: <EditCampaignTemplate />,
        state: "emailsystem.EditCampaignTemplate",

      },
    ],
  },

  //==================end========UserManagement==========


  //==================Start DocManagement====================
  {
    path: "/installation",
    element: <DashboardPageLayout />,
    state: "installation",
    child: [
      {
        index: true,
        element: <DashboardIndex />,
        state: "installation.index",
      },

      {
        path: "/installation/PoleInstallation",
        element: <PoleInstallation />,
        state: "installation.PoleInstallation",
        sidebarProps: {
          displayText: "Pole Installation",
        }
      },
      {
        path: "/installation/PoleInstallationAdd",
        element: <PoleInstallationAdd />,
        state: "installation.PoleInstallationAdd",
        // sidebarProps: {
        //   displayText: "Advertisement Entry Add",
        // }
      },
      {
        path: "/installation/PoleInstallationEdit",
        element: <PoleInstallationEdit />,
        state: "installation.PoleInstallationEdit",
      },


      {
        path: "/installation/LightInstallation",
        element: <LightInstallation />,
        state: "installation.LightInstallation",
        sidebarProps: {
          displayText: "Light Installation",
        }
      },
      {
        path: "/installation/LightInstallationAdd",
        element: <LightInstallationAdd />,
        state: "installation.LightInstallationAdd",
        // sidebarProps: {
        //   displayText: "Advertisement Entry Add",
        // }
      },
      {
        path: "/installation/LightInstallationEdit",
        element: <LightInstallationEdit />,
        state: "installation.LightInstallationEdit",
      },
      {
        path: "/installation/Lightswitchonoff",
        element: <Lightswitchonoff />,
        state: "master.Lightswitchonoff",

      },
      {
        path: "/installation/DeviceInstallMaster",
        element: <DeviceInstallMaster />,
        state: "installation.DeviceInstallMaster",
        sidebarProps: {
          displayText: "Device Installation",
        }
      },
      {
        path: "/installation/CreateDeviceInstall",
        element: <CreateDeviceInstall />,
        state: "installation.CreateDeviceInstall",
        // sidebarProps: {
        //   displayText: "Advertisement Entry Add",
        // }
      },
      {
        path: "/installation/EditDeviceInstall",
        element: <EditDeviceInstall />,
        state: "installation.EditDeviceInstall",
      },


      {
        path: "/installation/DeviceSchedule",
        element: <DeviceSchedule />,
        state: "installation.DeviceSchedule",
        sidebarProps: {
          displayText: "Device Schedule",
        }
      },
    ],
  },
  //===================End Library===================

  //==================Start Start Indent====================
  {
    path: "/staffindent",
    element: <DashboardPageLayout />,
    state: "staffindent",
    child: [
      {
        index: true,
        element: <DashboardIndex />,
        state: "staffindent.index",
      },

      {
        path: "/staffindent/StaffIndent",
        element: <StaffIndent />,
        state: "staffindent.StaffIndent",
        sidebarProps: {
          displayText: "Staff Indent",
        }
      },
      {
        path: "/staffindent/CreateStaffIndent",
        element: <CreateStaffIndent />,
        state: "staffindent.CreateStaffIndent",
      },
      {
        path: "/staffindent/EditStaffIndent",
        element: <EditStaffIndent />,
        state: "staffindent.EditStaffIndent",
      },

      {
        path: "/staffindent/StaffItemIssue",
        element: <StaffItemIssue />,
        state: "staffindent.StaffItemIssue",
        sidebarProps: {
          displayText: "Staff Item Issue",
        }
      },
      {
        path: "/staffindent/CreateStaffItemIssue",
        element: <CreateStaffItemIssue />,
        state: "staffindent.CreateStaffItemIssue",
      },
      {
        path: "/staffindent/EditStaffItemIssue",
        element: <EditStaffItemIssue />,
        state: "staffindent.EditStaffItemIssue",
      },

      {
        path: "/staffindent/StaffItemReturn",
        element: <StaffItemReturn />,
        state: "staffindent.StaffItemReturn",
        sidebarProps: {
          displayText: "Staff Item Return",
        }
      },
      {
        path: "/staffindent/CreateStaffItemReturn",
        element: <CreateStaffItemReturn />,
        state: "staffindent.CreateStaffItemReturn",
      },
      {
        path: "/staffindent/EditStaffItemReturn",
        element: <EditStaffItemReturn />,
        state: "staffindent.EditStaffItemReturn",
      },
    ],
  },
  //===================End Staff Indent===================

  //==================Start Complain====================
  {
    path: "/complaint",
    element: <DashboardPageLayout />,
    state: "complaint",
    child: [
      {
        index: true,
        element: <DashboardIndex />,
        state: "complaint.index",
      },

      {
        path: "/complaint/ComplaintMaster",
        element: <ComplaintMaster />,
        state: "complaint.ComplaintMaster",
        sidebarProps: {
          displayText: "Complaint",
        }
      },
      {
        path: "/complaint/CreateComplaint",
        element: <CreateComplaint />,
        state: "complaint.CreateComplaint",
      },
      {
        path: "/complaint/EditComplaint",
        element: <EditComplaint />,
        state: "complaint.EditComplaint",
      },
      {
        path: "/complaint/ComplainAssignMaster",
        element: <ComplainAssignMaster />,
        state: "complaint.ComplainAssignMaster",
        sidebarProps: {
          displayText: "Complain Assign",
        }
      },
      {
        path: "/complaint/ComplaintType",
        element: <ComplaintType />,
        state: "complaint.ComplaintType",
        sidebarProps: {
          displayText: "Complaint Type",
        }
      },
    ],
  },
  //===================End Complain===================

  //==================Start Report====================
  {
    path: "/report",
    element: <DashboardPageLayout />,
    state: "report",
    child: [
      {
        index: true,
        element: <DashboardIndex />,
        state: "report.index",
      },

      {
        path: "/report/StockLedgerReport",
        element: <StockLedgerReport />,
        state: "report.StockLedgerReport",
        sidebarProps: {
          displayText: "Stock Summary",
        },
      },


      {
        path: "/report/StockReport",
        element: <StockReport />,
        state: "report.StockReport",
        sidebarProps: {
          displayText: "Stock Report",
        },
      },

      {
        path: "/report/Escrap",
        element: <Escrap />,
        state: "report.Escrap",
        sidebarProps: {
          displayText: "Escrap",
        },
      },


      {
        path: "/report/PoleInstallReport",
        element: <PoleInstallReport />,
        state: "report.PoleInstallReport",
        sidebarProps: {
          displayText: "Pole Installed Report",
        },
      },


      {
        path: "/report/MrnReport",
        element: <MrnReport />,
        state: "report.MrnReport",
        sidebarProps: {
          displayText: "MRN Details Report",
        },
      },


      {
        path: "/report/QcReport",
        element: <QcReport />,
        state: "report.QcReport",
        sidebarProps: {
          displayText: "Quality Check Report",
        },
      },


      {
        path: "/report/PurchaseBillReport",
        element: <PurchaseBillReport />,
        state: "report.PurchaseBillReport",
        sidebarProps: {
          displayText: "Purchase Bill Report",
        },
      },


      {
        path: "/report/ComplaintsReport",
        element: <ComplaintsReport />,
        state: "report.ComplaintsReport",
        sidebarProps: {
          displayText: "Complaints Report",
        },
      },
    ],
  },
  //===================End Report===================

   //==================Start Admin====================
   {
    path: "/admin",
    element: <DashboardPageLayout />,
    state: "admin",
    child: [
      {
        index: true,
        element: <DashboardIndex />,
        state: "admin.index",
      },

      {
        path: "/admin/IndentApproval",
        element: <IndentApproval />,
        state: "admin.IndentApproval",
        sidebarProps: {
          displayText: "Indent Approval",
        }
      },
      {
        path: "/admin/CreateIndentApproval",
        element: <CreateIndentApproval />,
        state: "admin.CreateIndentApproval",
      },
      {
        path: "/admin/EditIndentApproval",
        element: <EditIndentApproval />,
        state: "admin.EditIndentApproval",
      },
      {
        path: "/admin/ComplainApproval",
        element: <ComplainApproval/>,
        state: "admin.ComplainApproval",

      },


      {
        path: "/admin/ComplainApprovalMaster",
        element: <ComplainApprovalMaster/>,
        state: "admin.ComplainApprovalMaster",

      },
    ],
  },
  //===================End Admin===================

  // {
  //   path: "/Inventory/IndentApproval",
  //   element: <IndentApproval />,
  //   state: "Inventory.IndentApproval",
  //   sidebarProps: {
  //     displayText: "Indent Approval",
  //   }
  // },
  // {
  //   path: "/Inventory/CreateIndentApproval",
  //   element: <CreateIndentApproval/>,
  //   state: "Inventory.CreateIndentApproval",
  // },
  // {
  //   path: "/Inventory/EditIndentApproval",
  //   element: <EditIndentApproval/>,
  //   state: "Inventory.EditIndentApproval",
  // },


  // {
  //   path: "/Inventory/ForwardLevel",
  //   element: <ForwardLevel />,
  //   state: "Inventory.ForwardLevel",
  //   sidebarProps: {
  //     displayText: "Forward Level",
  //   }
  // },
  // {
  //   path: "/Inventory/CreateForwardLevel",
  //   element: <CreateForwardLevel/>,
  //   state: "Inventory.CreateForwardLevel",
  // },
  // {
  //   path: "/Inventory/EditForwardLevel",
  //   element: <EditForwardLevel/>,
  //   state: "Inventory.EditForwardLevel",
  // },
  // {
  //   path: "/Inventory/IndentStore",
  //   element: <IndentStore />,
  //   state: "Inventory.IndentStore",
  //   sidebarProps: {
  //     displayText: "Indent Store",
  //   }
  // },
  // {
  //   path: "/Inventory/CreateIndentStore",
  //   element: <CreateIndentStore/>,
  //   state: "Inventory.CreateIndentStore",
  // },
  // {
  //   path: "/Inventory/EditIndentStore",
  //   element: <EditIndentStore/>,
  //   state: "Inventory.EditIndentStore",
  // },



  //==================end========UserManagement==========


  /////-------------------start ------UserManagement-----------------------

  {
    path: "/UserManagement",
    element: <DashboardPageLayout />,
    state: "UserManagement",
    sidebarProps: {
      displayText: "User Management",
      icon: <DashboardOutlinedIcon />
    },
    child: [
      {
        index: true,
        element: <DashboardIndex />,
        state: "UserManagement.index",
      },

      {
        path: "/UserManagement/UserManagement",
        element: <UserManagement />,
        state: "UserManagement.UserManagement",
        sidebarProps: {
          displayText: "User Management  Master",
        }
      },
      {
        path: "/UserManagement/UserManagementAdd",
        element: <UserManagementAdd />,
        state: "UserManagement.UserManagementAdd",
        // sidebarProps: {
        //   displayText: "Advertisement Entry Add",
        // }
      },
      {
        path: "/UserManagement/UserManagementEdit",
        element: <UserManagementEdit />,
        state: "UserManagement.UserManagementEdit",
      },
      {
        path: "/UserManagement/UserType",
        element: <UserType />,
        state: "UserManagement.UserType",
        sidebarProps: {
          displayText: "User Type",
        }
      },
      {
        path: "/UserManagement/RoleMaster",
        element: <RoleMaster />,
        state: "UserManagement.RoleMaster",
        sidebarProps: {
          displayText: "Role Master",
        },
      },
      {
        path: "/UserManagement/UserPermissionMaster",
        element: <UserPermissionMaster />,
        state: "UserManagement.UserPermissionMaster",
        sidebarProps: {
          displayText: "User Permission",
        },
      },
    ]

  },

  //==================end========UserManagement==========

  //==================== Start Employee Information====================
  {
    path: "/Employee",
    element: <DashboardPageLayout />,
    state: "Employee",
    sidebarProps: {
      displayText: "Employee",
      icon: <DashboardOutlinedIcon />,
    },
    child: [
      {
        index: true,
        element: <DashboardIndex />,
        state: "employeeinfo.index",
      },
      {
        path: "/Employee/EmployeeMaster",
        element: <EmployeeMaster />,
        state: "Employee.EmployeeMaster",
        sidebarProps: {
          displayText: "Employee Master",
        }
      },
      {
        path: "/Employee/EmployeeAdd",
        element: <EmployeeAdd />,
        state: "Employee.EmployeeAdd",
      },
      {
        path: "/Employee/EmployeeEdit",
        element: <EmployeeEdit />,
        state: "Employee.EmployeeEdit",
      },


    ],
  },
  //==================User Management=========


  {
    path: "/UserManagement",
    element: <DashboardPageLayout />,
    state: "UserManagement",
    sidebarProps: {
      displayText: "User Management",
      icon: <DashboardOutlinedIcon />,
    },
    child: [
      {
        index: true,
        element: <DashboardIndex />,
        state: "UserManagement.index",
      },
      {
        path: "/UserManagement/UserManagement",
        element: <UserManagement />,
        state: "UserManagement.UserManagement",
        sidebarProps: {
          displayText: "User Management",
        }
      },
      {
        path: "/UserManagement/UserManagementAdd",
        element: <UserManagementAdd />,
        state: "UserManagement.UserManagementAdd",
      },
      {
        path: "/UserManagement/UserManagementEdit",
        element: <UserManagementEdit />,
        state: "UserManagement.UserManagementEdit",
      },


      {
        path: "/UserManagement/RoleMaster",
        element: <RoleMaster />,
        state: "UserManagement.RoleMaster",
        sidebarProps: {
          displayText: "Role Master",
        }
      },


    ],
  },
  {
    path: "/complaintmaster",
    element: <DashboardPageLayout />,
    state: "complaintmaster",
    sidebarProps: {
      displayText: "Complaint Master",
      icon: <DashboardOutlinedIcon />,
    },
    child: [
      {
        index: true,
        element: <DashboardIndex />,
        state: "complaintmaster.index",
      },
      {
        path: "/complaintmaster/ComplaintMaster",
        element: <ComplaintMaster />,
        state: "complaintmaster.ComplaintMaster",
        sidebarProps: {
          displayText: "Complaint",
        }
      },
      {
        path: "/complaintmaster/CreateComplaint",
        element: <CreateComplaint />,
        state: "complaintmaster.CreateComplaint",
      },
      {
        path: "/complaintmaster/EditComplaint",
        element: <EditComplaint />,
        state: "complaintmaster.EditComplaint",
      },
      {
        path: "/complaintmaster/ComplainAssignMaster",
        element: <ComplainAssignMaster />,
        state: "complaintmaster.ComplainAssignMaster",
        sidebarProps: {
          displayText: "Complain Assign Master",
        }
      },
      {
        path: "/complaintmaster/ComplaintType",
        element: <ComplaintType />,
        state: "complaintmaster.ComplaintType",
        sidebarProps: {
          displayText: "Complaint",
        }
      },



    ],
  },



  {
    path: "/Organisation",
    element: <DashboardPageLayout />,
    state: "Organisation",
    sidebarProps: {
      displayText: "Organisation",
      icon: <DashboardOutlinedIcon />,
    },
    child: [
      {
        index: true,
        element: <DashboardIndex />,
        state: "Organisation.index",
      },
      {
        path: "/Organisation/Organisation",
        element: <Institute/>,
        state: "Organisation.Organisation",
        sidebarProps: {
          displayText: "Organisation",
        }
      },
      {
        path: "/Organisation/OrganisationAdd",
        element: <InstituteAdd/>,
        state: "Organisation.OrganisationAdd",
      },
      {
        path: "/Organisation/OrganisationEdit",
        element: <InstituteEdit/>,
        state: "Organisation.OrganisationEdit",
      },


      {
        path: "/Organisation/PageSetup",
        element: <PageSetup/>,
        state: "Organisation.PageSetup",
      },


      {
        path: "/Organisation/HelpCreation",
        element: <HelpCreation />,
        state: "master.HelpCreation",
        sidebarProps: {
          displayText: "Help Creation",
        },
      },

      {
        path: "/Organisation/HelpDesk",
        element: <HelpDesk />,
        state: "master.HelpDesk",
        sidebarProps: {
          displayText: "Help Desk",
        },
      },
     

    ],
  },


];



export default appRoutes;

